<template>
  <BaseSvg viewBox="0 0 19 17" width="19" height="17" fill="none" class="check-icon">
    <path
      d="M0.764648 8.5998L7.23524 15.1998L17.8235 0.799805"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </BaseSvg>
</template>

<script>
import { BaseSvg } from '@clovyr/bed';

export default {
  name: 'CheckmarkIcon',
  components: {
    BaseSvg,
  },
};
</script>
